import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import Testimonials from '../Elements/Testimonials';

/**
 * Testimonial Controller
 *
 * @class
 */
class TestimonialController extends AbstractController {
	/**
	 * @constructor
	 */
  constructor() {
	super();

	Controller.registerController(this);
	this._registerElements(...Testimonials);
  }
}

export default new TestimonialController();
